

















import { Vue, Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import UserTreeView from '@/components/UserTreeView.vue';
import MarkersFilteringView from '@/components/MarkersFilteringView.vue';
import { IMarkers, IProject } from '@/interfaces/data';
import LeafletMapView from '@/components/LeafletMapView.vue';
import CoverageStatsView from '@/components/CoverageStatsView.vue';
import OverLayView from '@/components/OverLayView.vue';

@Component({
  components: {
    UserTreeView,
    MarkersFilteringView,
    LeafletMapView,
    CoverageStatsView,
    OverLayView
  }
})
export default class Leaflet extends Vue {}
